import React from 'react';
import styled from 'styled-components';
import {WarningIcon} from 'web-components/icons';

const StatusIndicatorWrapper = styled.div`
	display: inline-flex;
	height: 24px;
	align-items: center;
	padding: 6px 10px;
	border: 1px solid #fff;
	border-color: ${props => props.color};
	border-radius: 20px;
	font-size: 10px;
	color: ${props => props.color};
	white-space: nowrap;
	margin-right: 8px;
	cursor: ${props => props.clickable && 'pointer'};
	box-shadow: ${props => props.active && '0px 0px 0px 3px #8843EF'};
`;

const Dot = styled.div`
	width: 8px;
	height: 8px;
	background-color: ${props => props.color};
	border-radius: 50%;
	margin-right: 6px;
`;

const convertStatusColorToWarningVariant = statusColor => {
	switch (statusColor) {
		case '#ff3300':
			return WarningIcon.VARIANT.DANGER;
		case '#ffc107':
			return WarningIcon.VARIANT.WARNING;
		default:
			return WarningIcon.VARIANT.NO_WARNING;
	}
};

const getTextFromVariant = variant => {
	switch (variant) {
		case WarningIcon.VARIANT.DANGER:
			return 'Off track';
		case WarningIcon.VARIANT.WARNING:
			return 'At risk';
		default:
			return 'Good';
	}
};

export const StatusIndicator = ({warning, projectStatusColor, active, onClick}) => {
	const warningVariant = warning || convertStatusColorToWarningVariant(projectStatusColor);

	return (
		<StatusIndicatorWrapper color={warningVariant.color} active={active} onClick={onClick} clickable={onClick}>
			<Dot color={warningVariant.color}></Dot>
			{getTextFromVariant(warningVariant)}
		</StatusIndicatorWrapper>
	);
};
